import React, { Component } from 'react'
import { connect } from 'react-redux'
import authSelector from '../../../selectors/authSelector'
import AddSupportTicketForm from './AddSupportTicketForm'

class AddSupportTicket extends Component {

  render() {
    const props = {
      replyMode: false,
      userType: this.props.userType,
    }

    return (
      <div>
        <AddSupportTicketForm {...props} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    ...state.supportTickets,
    ...authSelector(state),
  }
}

export default connect(
  mapStateToProps,
)(AddSupportTicket)


// WEBPACK FOOTER //
// ./src/components/common/Support/AddSupportTicket.js